<template>
  <div class="informatedisclosure">
    <header-view :tabsign="7"></header-view>
    <div class="pic">政策法规</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>政策法规</span>
        </div>
      </div>

      <div class="centent">
        <div class="listb">
          <div v-for="(item, index) in list" :key="index">
            <!-- <router-link :to="'/noticeDetails?index=' + index + '&id=' + item.id"> -->
            <div @click="toDatail(index, item)" class="signleb">
              <div class="titlecon overf-elli" :title="item.title">
                {{ item.title || "" }}
              </div>
              <div class="timecon">
                {{ item.createTime || "" }}
              </div>
            </div>
            <!-- </router-link> -->
          </div>
        </div>
      </div>

      
    </div>
    <zhini-pagination
      class="zhini-pagination"
      :currentPage="pageNo"
      :totalPage="totalPage"
      @pageNum="pageNum"
    ></zhini-pagination>
  </div>
</template>

<script>
import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  name: "informatedisclosure",
  components: {
    zhiniPagination,
  },
  data: function () {
    return {
      list: "",
      pageNo: 1,
      pageSize: 15,
      totalPage: 0,
      url: "",

      typesign: 0,
      searchv: "",
    };
  },
  created() {
    this.init();
	window.pageYOffset = 0;
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
  },
  watch: {
    $route() {
      this.typesign = this.$route.query.type;
    },
    typesign() {
      this.typesign = this.$route.query.type;
      this.init();
    },
  },
  methods: {
    toDatail(indexsign, item) {
      this.$router.push({
        path: "/policiesregulationsdetail",
        query: { index: indexsign, id: item.id },
      });
    },

    //搜索值变化
    changeinput() {
      this.init();
    },

    init() {
      var that = this;
      this.httpGet("web/info/list", {
        infoType: "1",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        title: this.searchv,
      }).then((res) => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      this.pageNo = e;
      this.init();
    },
  },
  mounted() {},
};
</script>
<style scoped="scoped" lang="scss">
::-webkit-scrollbar {
  width: 0px;
}
.informatedisclosure {
  width: 100%;
  position: relative;
  .pic {
    width: 100%;
    height: 400px;
    font-size: 75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin: 22px auto 0px;
    .centent {
      margin: 0px auto;
      .listb {
        margin-top:20px;
        .signleb {
          padding-left: 20px;
          cursor: pointer;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          border-bottom: 1px dashed #e6e6e6;
          
          .titlecon {
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            width: calc(100% - 170px);
          }
          .titlecon:hover {
            color: rgba(230, 31, 38, 1);
          }
          .timecon {
            font-size:18px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .zhini-pagination {
      position: absolute;
      bottom: 10px;
      width: 100%;
      left: 0px;
    }

    .toptitle {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        .redcon {
          width: 5px;
          height: 20px;
          background: #e70012;
          margin-right: 20px;
        }
        font-size: 25px;
        font-weight: 400;
        color: #e61f26;
      }
    }
  }
}
</style>
